import React from "react";
// import { useHistory } from "react-router-dom";
import Card from "react-credit-cards";

import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
    routeChange=()=> {
        let path = `/`;
        // let history = useHistory();
        this.props.history.push(path);
      }
  render() {
  
    return (
      <div   >
      <h1><br />
      Developer API  <br />
        </h1>
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
       <h3 className="container">
    
Our API includes two paths <br/> <br/>
The first is the address of the referring site with the extension of /Credit-report<br/>
This call is a POST call that we send after each card entry is entered<br/>
The call returns to the referring site and allows it to save the order data<br/>
If the referring site does not handle this call, it will fail (but it will not affect the site's activity and card data retention)<br/>
This call allows the referring site to create a database of order data so that it can receive card information in the system, without having to save the data received by email<br/>
<br/>
 The second API is a path to get credit data<br/>
The path is: https://dugoly.com/api/receive_credit<br/>
A POST call must be made<br/>
The data object must include the following data:<br/>
customer_ID, transaction_ID<br/>
In cookies must be<br/>
Uid and dugolyToken (they are automatically accepted by dugoly login)<br/>
In case it is not possible to send cookies at all, the value "cookies" can also be sent in the data object, which contains the above data,<br/>
In structure:<br/>
cookies: `uid =… ..; dugolyToken = ……`<br/>
(Note that if any value is received in cookies, the system will not check at all the finding of the cookies in the object of the data, this value is only intended when it is not possible to send any cookies)<br/>
<br/>
<br/>
Example of a complete data object:<br/>

<p style={{textAlign: 'left'}}>&nbsp;const data={'{'} <br />

customer_ID:this.state.customer_ID, <br />
transaction_ID:this.state.transaction_ID, <br />
cookies:`uid=${'{'}this.getCookie("uid"){'}'};<br />
dugolyToken=${'{'}this.getCookie("dugolyToken"){'}'}` <br />{'}'}&nbsp;&nbsp;</p>

<br/>

The ideal form of use for these calls is:<br/>
Configure API to receive the report of a new receipt for credit data<br/>
And when the details are required, make a call for credit data, after logging in with dugoly<br/>

</h3>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/');}}>back to home</button>

        
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/Developer_API.js